import Alpine from "alpinejs";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "cookies.js";

// ALPINE PLUGINS
import ui from "@alpinejs/ui";
Alpine.plugin(ui);
import collapse from "@alpinejs/collapse";
Alpine.plugin(collapse);
import focus from "@alpinejs/focus";
Alpine.plugin(focus);
import dialog from "./directives/dialog";
Alpine.plugin(dialog);

// CUSTOM ALPINE PLUGINS
import form from "./directives/form";
Alpine.directive("form", form);
import mask from "./directives/mask";
Alpine.directive("mask", mask);
import format from './magics/format';
Alpine.magic('format', format);

// CUSTOM ALPINE COMPONENTS
import coursesList from "./components/coursesList";
Alpine.data("coursesList", coursesList);
import eventDetails from "./components/eventDetails";
Alpine.data("eventDetails", eventDetails);
import eventList from "./components/eventList";
Alpine.data("eventList", eventList);
import forgotPasswordForm from "./components/forgotPasswordForm";
Alpine.data('forgotPasswordForm', forgotPasswordForm)
import instructorsList from "./components/instructorsList";
Alpine.data('instructorsList', instructorsList);
import internationalEventList from "./components/internationalEventList";
Alpine.data('internationalEventList', internationalEventList);
import loginForm from "./components/loginForm";
Alpine.data('loginForm', loginForm);
import newsList from "./components/newsList";
Alpine.data('newsList', newsList);
import olliCoursesList from "./components/olliCoursesList";
Alpine.data("olliCoursesList", olliCoursesList);
import programCourseList from "./components/programCourseList";
Alpine.data("programCourseList", programCourseList);
import studentCoursesByTerm from "./components/studentCoursesByTerm";
Alpine.data("studentCoursesByTerm", studentCoursesByTerm);
import studentPendingCoursesList from "./components/studentPendingCoursesList";
Alpine.data("studentPendingCoursesList", studentPendingCoursesList);
import cartList from "./components/cartList";
Alpine.data('cartList', cartList);
import setPasswordForm from "./components/setPasswordForm";
Alpine.data('setPasswordForm', setPasswordForm);
import myAccountStatement from "./components/myAccountStatement";
Alpine.data("myAccountStatement", myAccountStatement);
import myDocuments from "./components/myDocuments";
Alpine.data("myDocuments", myDocuments);
import uCInetIDList from "./components/uCInetIDList";
Alpine.data("uCInetIDList", uCInetIDList);
import coursePreRequisitesList from "./components/coursePreRequisitesList";
Alpine.data("coursePreRequisitesList", coursePreRequisitesList);
import uploadDocument from "./components/uploadDocument";
Alpine.data("uploadDocument", uploadDocument);
import newsBlogFeedList from "./components/newsBlogFeedList";
Alpine.data("newsBlogFeedList", newsBlogFeedList);
import gradeOptionDiscount from "./components/gradeOptionDiscount";
Alpine.data("gradeOptionDiscount", gradeOptionDiscount);
import searchList from "./components/SearchList";
Alpine.data("searchList", searchList);
import feeSummary from "./components/feeSummary";
Alpine.data("feeSummary", feeSummary);
import cartSummary from "./components/cartSummary";
Alpine.data("cartSummary", cartSummary);
import myProfile from "./components/myProfile";
Alpine.data("myProfile", myProfile);
import updatePersonalInformation from "./components/updatePersonalInformation";
Alpine.data("updatePersonalInformation", updatePersonalInformation);

import cartConfirmation from "./components/cartConfirmation";
Alpine.data("cartConfirmation", cartConfirmation);
import updateEmail from "./components/updateEmail";
Alpine.data("updateEmail", updateEmail);
import updateAddress from "./components/updateAddress";
Alpine.data("updateAddress", updateAddress);
import updatePhones from "./components/updatePhones";
Alpine.data("updatePhones", updatePhones);
import verifyPassword from "./components/verifyPassword";
Alpine.data("verifyPassword", verifyPassword);
import resetQuestions from "./components/resetQuestions";
Alpine.data("resetQuestions", resetQuestions);
import gradeOptionEdit from "./components/gradeOptionEdit";
Alpine.data("gradeOptionEdit", gradeOptionEdit);
import unofficialTranscripts from "./components/unofficialTranscripts";
Alpine.data("unofficialTranscripts", unofficialTranscripts);
import enrollmentVerification from "./components/enrollmentVerification";
Alpine.data("enrollmentVerification", enrollmentVerification);
import declarationofCandidacy from "./components/declarationofCandidacy";
Alpine.data("declarationofCandidacy", declarationofCandidacy);
import basketList from "./components/basketList";
Alpine.data("basketList", basketList);
import basketFeeSummary from "./components/basketFeeSummary";
Alpine.data("basketFeeSummary", basketFeeSummary);
import basketCartSummary from "./components/basketCartSummary";
Alpine.data("basketCartSummary", basketCartSummary);
import paralegalPartTime from "./components/paralegalPartTime";
Alpine.data("paralegalPartTime", paralegalPartTime);
import duplicateCertificate from "./components/duplicateCertificate";
Alpine.data("duplicateCertificate", duplicateCertificate);
import basketCartConfirmation from "./components/basketCartConfirmation";
Alpine.data("basketCartConfirmation", basketCartConfirmation);
import myCertificates from "./components/myCertificates";
Alpine.data("myCertificates", myCertificates);

import olliCartList from "./components/olliCartList";
Alpine.data("olliCartList", olliCartList);
import olliCartFeeSummary from "./components/olliCartFeeSummary";
Alpine.data("olliCartFeeSummary", olliCartFeeSummary);
import olliCartSummary from "./components/olliCartSummary";
Alpine.data("olliCartSummary", olliCartSummary);
import olliCartConfirmation from "./components/olliCartConfirmation";
Alpine.data("olliCartConfirmation", olliCartConfirmation);
import instructorCourseMaintenance from "./components/instructorCourseMaintenance";
Alpine.data("instructorCourseMaintenance", instructorCourseMaintenance);
import instructorClassRoster from "./components/instructorClassRoster";
Alpine.data("instructorClassRoster", instructorClassRoster);
import olliMembershipOptions from "./components/olliMembershipOptions";
Alpine.data("olliMembershipOptions", olliMembershipOptions);
import finalGrade from "./components/finalGrade";
Alpine.data("finalGrade", finalGrade);
import coursesAvailableToDrop from "./components/coursesAvailableToDrop";
Alpine.data("coursesAvailableToDrop", coursesAvailableToDrop);
import pendingDrops from "./components/pendingDrops";
Alpine.data("pendingDrops", pendingDrops);
import completeDropCourses from "./components/completeDropCourses";
Alpine.data("completeDropCourses", completeDropCourses);
import parchmentSSO from "./components/parchmentSSO";
Alpine.data("parchmentSSO", parchmentSSO);
import activityCartList from "./components/activityCartList";
Alpine.data("activityCartList", activityCartList);
import activityFeeSummary from "./components/activityFeeSummary";
Alpine.data("activityFeeSummary", activityFeeSummary);
import activityCartSummary from "./components/activityCartSummary";
Alpine.data("activityCartSummary", activityCartSummary);
import activityCartConfirmation from "./components/activityCartConfirmation";
Alpine.data("activityCartConfirmation", activityCartConfirmation);
import myAccountWelcome from "./components/myAccountWelcome";
Alpine.data("myAccountWelcome", myAccountWelcome);
import updateProfileDetails from "./components/updateProfileDetails";
Alpine.data("updateProfileDetails", updateProfileDetails);
import logout from "./components/logout";
Alpine.data("logout", logout);

// CUSTOM ALPNE STORES
import schemas from "./validation-schemas";
Alpine.store('schemas', schemas)

const closePopup = document.querySelector(".close-fb");

if (closePopup !== null) {
  closePopup.addEventListener("click", function () {
    Fancybox.close();
  });
}

const cartRegister = document.querySelector(".cart-register");


// Custom
var widgetCardIcon = document.querySelectorAll(".widget-card-icon");

if (typeof widgetCardIcon !== "undefined" && widgetCardIcon !== null) {
  widgetCardIcon.forEach((el) => {
    el.closest(".grid").classList.remove("gap-5");
    el.closest(".grid").classList.add("gap-10");
    el.closest(".grid").classList.add("mt-14");
    el.closest(".grid").classList.add("mb-14");
  });
}

var acc = document.querySelectorAll(".faq-accordion");

acc.forEach((el) => {
  el.addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.classList.contains("hidden")) {
      panel.classList.remove("hidden");
    } else {
      panel.classList.add("hidden");
    }
  });
});

var courseContainer = document.querySelectorAll(".course-container");
var notifyBtn = document.querySelectorAll(".notify-me");


courseContainer.forEach((el) => {
    el.addEventListener('click', function (e) {
        const courseDetails = el.querySelector('.courseDetails_'+e.target.id.split('_')[1]);
        if (e.target.tagName.toLowerCase() == 'button') {
           
                if (e.target.classList.contains("see-details")) {
                    e.target.classList.toggle("active");
                    if (!courseDetails.classList.contains('hidden')) {
                        courseDetails.classList.add('hidden');
                    } else {
                        courseDetails.classList.remove('hidden');
                    }
                }
            
        }
    });
});

courseContainer.forEach((el) => {
    el.addEventListener('click', function (e) {
        const courseDetails = el.querySelector('.courseDetails_' + e.target.id.split('_')[1]);
        if (e.target.tagName.toLowerCase() == 'button') {

            if (e.target.classList.contains("see-details-btn")) {
                e.target.classList.toggle("active");
                if (!courseDetails.classList.contains('hidden')) {
                    courseDetails.classList.add('hidden');
                } else {
                    courseDetails.classList.remove('hidden');
                }
            }

        }
    });
});

courseContainer.forEach((el) => {
    el.addEventListener('click', function (e) {
        const courseDetails = el.querySelector('.courseDetails_' + e.target.id.split('_')[1]);
        if (e.target.tagName.toLowerCase() == 'button') {

            if (e.target.classList.contains("button.notify-me")) {
                e.target.classList.toggle("active");
                if (!courseDetails.classList.contains('hidden')) {
                    courseDetails.classList.add('hidden');
                } else {
                    courseDetails.classList.remove('hidden');
                }
            }

        }
    });
});


notifyBtn.forEach((el) => {
  el.addEventListener("click", function () {
    var course = el.closest(".course-container");
    var details = course.querySelector(".course-details");

    if (details.classList.contains("hidden")) {
      details.classList.remove("hidden");
    } else {
      details.classList.add("hidden");
    }
  });
});

const passwordToggle = document.querySelectorAll('.password-tog');

passwordToggle.forEach((el) => {
    const icon = el.querySelector("use");

    el.addEventListener("click", function (event) {
        event.preventDefault();
        const passwordField = el.previousElementSibling;

        if (passwordField.type === "password") {
            passwordField.type = "text";
            icon.setAttribute("href", "/static/dist/assets/icons.svg#password-show")
        } else {
            passwordField.type = "password";
            icon.setAttribute("href", "/static/dist/assets/icons.svg#password")
        }
    });
});

const staffImage = document.querySelectorAll('.staff-card .bg-quaternary img');

staffImage.forEach((el) => {
    let imageHeight = el.naturalHeight;

    if(imageHeight >= 280){
        el.classList.add('h-full')
    }
});

Fancybox.bind("[data-fancybox]", {
    dragToClose: false,
    backdropClick: false,
});

Fancybox.bind("[data-fb-remove]", {
    dragToClose: false,
    backdropClick: false,
    mainClass: 'uciAlert'
});

// INIT
window.Alpine = Alpine;
Alpine.start();
